import { jsx } from 'react/jsx-runtime';
import { MemberBarResourcerWithLiveBlocks } from '../../../../multiplayer/components/MemberBar/MemberBarResourceWithLiveBlock.js';
import { useResourceDataContextSafe } from '../../context/resourceDataContext.js';
import { resourceSharingModal } from '../../../../permission/components/ModalShare/resourceSharingStore.js';

const ModalExpandedResourceMemberBar = () => {
  const { resource, disabledActions } = useResourceDataContextSafe();
  return /* @__PURE__ */ jsx(MemberBarResourcerWithLiveBlocks, {
    resourceId: resource.id,
    isPublicShared: resource.isShared || false,
    hideShareButton: true,
    onOpenShareModal: disabledActions.manageSomePermissionRoles ? void 0 : () => resourceSharingModal.open({
      resourceId: resource.id
    })
  });
};

export { ModalExpandedResourceMemberBar };
//# sourceMappingURL=ModalExpandedResourceMemberBar.js.map
